import {
  ButtonTracking,
  ScreenTracking,
  SCREEN_ASSET_ID
} from '../../../domain/amplitude'
import { CreditCardDetails } from '../../../domain/creditCard'
import { PROCESSING_SCREEN } from '../ApplicationSubmitted/types'

export enum CreditCardErrors {
  HTTP,
  GENERIC,
  REJECTED
}

export type CreditCardError = {
  type: CreditCardErrors
  errorMessage: string
}

export type CreditCardSubmittedProps = {
  cardId: string
  handleReady: (creditCard: CreditCardDetails) => void
  handleError: (error: CreditCardError) => void
}

export type CreditCardErrorProps = {
  error: CreditCardError
}

export type CreditCardReadyProps = {
  cardDetails: CreditCardDetails
}

const CARD_CONF_SCREEN = 'cardConfirmation'

export const CardConfirmationScreenOpened: ScreenTracking = {
  asset_id: SCREEN_ASSET_ID,
  screen: CARD_CONF_SCREEN,
  from_screen: PROCESSING_SCREEN,
  heading: 'Your Paceline Card is on its way!'
}

export const AppDownloadButtonEvent: ButtonTracking = {
  asset_id: 'downloadButton',
  asset_text: 'Download on the App Store',
  screen: CARD_CONF_SCREEN
}
